import { render } from "./PasswordChangePage.vue?vue&type=template&id=2ad71a69&scoped=true&ts=true"
import script from "./PasswordChangePage.vue?vue&type=script&lang=ts"
export * from "./PasswordChangePage.vue?vue&type=script&lang=ts"

import "./PasswordChangePage.vue?vue&type=style&index=0&id=2ad71a69&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad71a69"]])

export default __exports__